// extracted by mini-css-extract-plugin
export var fileUpload = "_i3-1";
export var modalButton = "_i3-0";